import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { ReportsShadcnComponent } from 'app/components/reports/ReportsShadcnComponent'

const validator = withZod(z.object({}))

export default function ReportsView(): React.ReactElement {
  return <ReportsShadcnComponent validator={validator} />
}
